// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home{cursor:pointer;margin-left:15px}.home:hover{color:#6495ed}.class{width:100%;height:64px;overflow:hidden;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
